'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _type = require('./type');

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

var _style = require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modal = weex.requireModule('modal'); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var dom = weex.requireModule('dom');
exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { DofIconfont: _dofIconfont2.default },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: 'text'
    },
    returnKeyType: {
      type: String,
      default: 'search'
    },
    mod: {
      type: String,
      default: 'default'
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'white'
    },
    barStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    defaultValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '搜索'
    },
    // 是否显示右侧按钮区域
    showRightContent: {
      type: Boolean,
      default: false
    },

    rightLabel: {
      type: String,
      default: '搜索 '
    },

    backArrow: {
      type: Boolean,
      default: false
    },

    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    selectedText: {
      type: String,
      default: ''
    },
    inputWidth: {
      type: Number,
      default: 0
    }
  },
  computed: {
    themeStyle: function themeStyle() {
      var _theme = this._isColmo ? 'colmo' : 'default';
      return _style.STYLE_MAP[_theme] || _style.STYLE_MAP['default'];
    },
    buttonStyle: function buttonStyle() {
      var barStyle = this.barStyle;

      if (barStyle.backgroundColor) {
        return { backgroundColor: barStyle.backgroundColor };
      }
      return {};
    },
    inputIcon: function inputIcon() {
      if (this.theme == 'black') {
        return this.inputIconWhite;
      }
      return this.inputIconBlack;
    }
  },
  data: function data() {
    return {
      test: '\u4785',
      inputIconBlack: _type.INPUT_ICON,
      inputIconWhite: _type.INPUT_ICON_WHITE,
      closeIcon: _type.CLOSE_ICON,
      arrowIcon: _type.ARROW_ICON,
      B_backArrowIcon: _type.BACK_ARROW_ICON,
      W_backArrowIcon: _type.WHITE_ARROW_ICON,
      showClose: false,
      value: '',
      selectList: false,
      selectBlockStyle: {}
    };
  },
  created: function created() {
    this.defaultValue && (this.value = this.defaultValue);
    if (this.disabled) {
      this.showClose = false;
    }
  },

  methods: {
    onBlur: function onBlur() {
      var self = this;
      setTimeout(function () {
        self.detectShowClose();
        self.$emit('dofSearchbarInputOnBlur', { value: self.value });
      }, 10);
    },
    autoBlur: function autoBlur() {
      this.$refs['search-input'].blur();
    },
    onFocus: function onFocus() {
      if (this.isDisabled) {
        return;
      }
      this.detectShowClose();
      this.$emit('dofSearchbarInputOnFocus', { value: this.value });
    },
    closeClicked: function closeClicked() {
      this.value = '';
      this.showClose && (this.showClose = false);
      this.$emit('dofSearchbarClearClicked', { value: this.value });
      // this.$emit('dofSearchbarInputOnInput', { value: this.value });
    },
    onInput: function onInput(e) {
      this.value = e.value;
      this.detectShowClose();
      this.$emit('dofSearchbarInputOnInput', { value: this.value });
    },
    onSubmit: function onSubmit(e) {
      this.onBlur();
      this.value = e.value;
      this.detectShowClose();
      this.$emit('dofSearchbarInputReturned', { value: this.value });
    },
    rightClicked: function rightClicked() {
      this.showClose && (this.showClose = false);
      this.$emit('dofSearchbarRightClicked', { value: this.value });
    },
    detectShowClose: function detectShowClose() {
      // this.showClose = (this.value.length > 0) && this.showRightContent;
      this.showClose = this.value.length > 0;
    },
    inputDisabledClicked: function inputDisabledClicked() {
      this.$emit('dofSearchbarInputDisabledClicked', {});
    },
    setValue: function setValue(value) {
      this.value = value;
    },
    backArrowClicked: function backArrowClicked() {
      this.$emit('dofBackArrowClicked', {});
    },


    // 显示下拉列表
    showSelectList: function showSelectList() {
      var _this = this;

      dom.getComponentRect(this.$refs.selectedText, function (rect) {
        _this.selectBlockStyle = {
          top: rect.size.top,
          left: rect.size.left
        };
      });
      this.selectList = !this.selectList;
    },
    selectItem: function selectItem(item) {
      this.selectedText = item;
      this.selectList = false;
      this.$emit('dofSelectItemClicked', { item: item });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-searchbar/index.vue
// module id = 381
// module chunks = 0 1